import React, { useState, useEffect } from "react";
import { Button, Form, Table, Spinner } from "react-bootstrap";
import { ApiHelper } from "../../utils/ApiHelper";
import { USERS_DATA } from "../../lib/API_KEYS";
import { projectManagerRoles } from "../../config/ROLES";
import ProtectedButton from "../RBAC/ProtectedButton";

export default function AppointProjectManagerModal({ show, onClose, onSave, selectedPM, setSelectedPM }) {
    const [industry, setIndustry] = useState("Aerospace");
    const [expertise, setExpertise] = useState("Precision Machining");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!show) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await new ApiHelper().FetchFromServer(...USERS_DATA, {
                    role: projectManagerRoles,
                });
                setData(res.data.results || []);
            } catch (err) {
                console.error("Error fetching project managers:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [show]);

    const handleSelect = (id) => {
        setSelectedPM((prev) =>
            prev === id ? null : id
        );
    };

    // const handleSave = () => {
    //     onSave(selectedPM); // Pass selected IDs back to parent
    // };

    if (!show) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(4px)",
                zIndex: 1200,
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "1000px", width: "90%" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content p-5 rounded-4 shadow"
                    style={{
                        background: "#fff",
                        borderRadius: "8px",
                        padding: "20px",
                        width: "100%",
                        maxWidth: "1000px",
                    }}
                >
                    <h4 className="fw-bold mb-4" style={{ color: "#071437" }}>
                        Select a Project Manager
                    </h4>

                    {/* Dropdown Filters */}
                    <div className="d-flex gap-3 mb-4">
                        <div className="w-50">
                            <label className="form-label fw-semibold" style={{ fontSize: "14px" }}>
                                Industry Classification
                            </label>
                            <Form.Select
                                value={industry}
                                onChange={(e) => setIndustry(e.target.value)}
                            >
                                <option>Aerospace</option>
                                <option>Automotive</option>
                                <option>Construction</option>
                            </Form.Select>
                        </div>

                        <div className="w-50">
                            <label className="form-label fw-semibold" style={{ fontSize: "14px" }}>
                                Industry Expertise
                            </label>
                            <Form.Select
                                value={expertise}
                                onChange={(e) => setExpertise(e.target.value)}
                            >
                                <option>Precision Machining</option>
                                <option>Electronics</option>
                                <option>Tooling</option>
                            </Form.Select>
                        </div>
                    </div>

                    {/* Project Manager Table */}
                    <div className="table-responsive mb-4" style={{ overflowX: "auto" }}>
                        {loading ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        ) : (
                            <Table bordered hover className="align-middle">
                                <thead className="table-light">
                                    <tr>
                                        {/* <th style={{ width: "5%" }}>#</th> */}
                                        <th style={{ width: "5%" }}>Select</th> {/* ✅ new column */}
                                        <th>PM Name</th>
                                        <th>Email ID</th>
                                        {/* <th>Phone Number</th> */}
                                        <th>Active Projects</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((pm, index) => (
                                            <tr key={pm._id || pm.id}>
                                                {/* <td>{String(index + 1).padStart(2, "0")}</td> */}
                                                <td className="text-center">
                                                    <Form.Check
                                                        type="radio"
                                                        name="pmSelect"
                                                        checked={selectedPM === pm._id}
                                                        onChange={() => handleSelect(pm._id)}
                                                    />
                                                </td>
                                                <td>{pm.name}</td>
                                                <td>{pm.email}</td>
                                                {/* <td>{pm.phone}</td> */}
                                                <td>{pm.activeProjectCount ?? 0}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center py-3 text-muted">
                                                No project managers found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </div>

                    {/* Footer Buttons */}
                    <div className="d-flex justify-content-end gap-3">
                        <ProtectedButton
                            permission="appointProjectManager"
                            variant="outline-secondary"
                            className="px-4"
                            onClick={onClose}
                            style={{ minWidth: "120px" }}
                        >
                            Cancel
                        </ProtectedButton>
                        <ProtectedButton
                            permission="appointProjectManager"
                            className="px-4"
                            style={{
                                backgroundColor: "#181D4C",
                                color: "#fff",
                                minWidth: "120px",
                            }}
                            onClick={onSave}
                            disabled={!selectedPM}
                        >
                            Save
                        </ProtectedButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
